import { Section, TwoColumns } from '../Section';
import { SectionTitle, StyledLinkA } from '../Typography';

import { DescriptionBlock } from '../DescriptionBlock/index';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';
import sizes from 'src/style/sizes';

const WhyJS = () => {
  return (
    <Section theme="secondary">
      <TwoColumns
        sizeLeft={sizes.columnWidth.medium}
        left={
          <div>
            <SectionTitle>Pourquoi le JavaScript&nbsp;?</SectionTitle>
            <StaticImage
              src="../../../src/data/images/2023_learnJS.jpg"
              alt="Pourquoi apprendre le JavaScript"
              // placeholder="none"
              css={{
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: 5,
                marginTop: 50,
                boxShadow: '5px 25px 40px rgba(0, 0, 0, 0.2)',
                [mediaQueries.phoneOnly]: {
                  height: '70%',
                  marginTop: 30,
                },
                [mediaQueries.tabletPortraitUp]: {
                  height: '70%',
                },
                [mediaQueries.tabletLandscapeUp]: {
                  height: '100%',
                },
              }}
            />
          </div>
        }
        sizeRight={sizes.columnWidth.medium}
        right={
          <div>
            <DescriptionBlock title="Il s'agit du langage le plus populaire au monde">
              Le site{' '}
              <StyledLinkA
                color={colors.purple}
                href="https://survey.stackoverflow.co/2023/#programming-scripting-and-markup-languages"
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                StackOverFlow
              </StyledLinkA>{' '}
              positionne JavaScript au rang de langage le plus populaire. C'est un fait : 65% des
              développeurs utilisent ce langage. À titre de comparaison : 20% pour le PHP et 6% pour
              le Ruby. Faire autre chose que du JavaScript en 2024 est une erreur.
            </DescriptionBlock>
            <DescriptionBlock title="Il est doté d'une flexibilité hors-normes">
              Le JavaScript est le seul langage qui s'exécute côté navigateur et côté serveur. Sa
              flexibilité vous permet facilement de développer des sites Web et des applications
              Mobile en peu de temps, notamment grâce à React et React Native.
            </DescriptionBlock>
            <DescriptionBlock title="C'est le plus demandé sur le marché de l'emploi">
              Le JavaScript est tellement puissant qu'il est devenu le langage de prédilection de
              toutes les startups. Les offres d'emploi sur cette technologie sont supérieures à
              n'importe quel autre langage. Par exemple, voici pour ce que cela donne lorsque l'on
              recherche sur{' '}
              <StyledLinkA
                color={colors.purple}
                href="https://www.welcometothejungle.co/fr/jobs?query=react"
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                React
              </StyledLinkA>{' '}
              (JavaScript),{' '}
              <StyledLinkA
                color={colors.purple}
                href="https://www.welcometothejungle.co/fr/jobs?query=php"
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                PHP
              </StyledLinkA>{' '}
              ou{' '}
              <StyledLinkA
                color={colors.purple}
                href="https://www.welcometothejungle.co/fr/jobs?query=ruby"
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                Ruby
              </StyledLinkA>
              . La différence est édifiante !
            </DescriptionBlock>
          </div>
        }
      />
    </Section>
  );
};

export default WhyJS;
